export class PeopleProfiles implements IResponseList<IPeopleProfile> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IPeopleProfile[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    (this.status_code = 200), (this.data = []);
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class PeopleProfileQuickView implements IResponse<IPeopleProfileQuickView> {
  message?: string | undefined;
  status_code: number;
  data: IPeopleProfileQuickView;
  detail?: string | undefined;
  errors?: ExpectedAny[] | undefined;
  limit?: number | undefined;
  offset?: number | undefined;
  total_pages?: number | undefined;
  constructor() {
    this.data = { uuid: null, skills: [], companies: [], category: [] };
    this.status_code = 200;
  }
}

export class PeopleDetail implements IResponse<IPeopleDetail> {
  message: string;
  status_code: number;
  data: IPeopleDetail;
  detail?: string;
  errors?: ExpectedAny[];
  constructor() {
    this.message = '';
    this.data = {
      id: '',
      image_url: '',
      full_name: '',
      phone_numbers: [],
      birthday: '',
      country_name: '',
      country_code: '',
      is_sanctioned: false,
      description: '',
      job_summary: '',
      websites: [],
      emails: [],
      linkedin_url: '',
      twitter_url: '',
      facebook_url: '',
      addresses: [],
      educations: [],
      category: [],
      skills: [],
      updated_at: '',
    };
    this.status_code = 200;
  }
}

export class PeopleRelatedCompany implements IResponseList<IPeopleRelatedCompany> {
  status_code: number;
  data: IPeopleRelatedCompany[];
  message?: string;
  warning?: string | null | undefined;
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class PeopleRelatedPeoples implements IResponseList<IPeopleRelatedPeople> {
  status_code: number;
  data: IPeopleRelatedPeople[];
  message?: string;
  warning?: string | null | undefined;
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class PeopleInformationSuggestion implements IResponseList<string> {
  status_code: number;
  data: string[] | Array<ExpectedAny>;
  message?: string;
  warning?: string | null | undefined;
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  constructor() {
    this.status_code = 200;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class AlertPeople implements IResponseList<IAlertPeople> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IAlertPeople[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_docs_count: number;
  total_records: number;
  constructor() {
    (this.status_code = 200), (this.data = []);
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_docs_count = 0;
    this.total_records = 0;
  }
}

export class AlertDetailPeople implements IResponse<IAlertPeople> {
  message: string;
  status_code: number;
  data: IAlertPeople;
  detail?: string;
  errors?: ExpectedAny[];
  constructor() {
    this.message = '';
    this.data = {
      id: '',
      country: null,
      source_link: null,
      authority: '',
      program: '',
      start_date: '',
      end_date: '',
    };
    this.status_code = 200;
  }
}

export class EmailValidationPeople implements IResponseList<IEmailValidationPeople> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IEmailValidationPeople[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_docs_count: number;
  total_records: number;
  constructor() {
    (this.status_code = 200), (this.data = []);
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_docs_count = 0;
    this.total_records = 0;
  }
}

export class EmailValidationPeopleDetail implements IResponse<IEmailValidationPeople> {
  message: string;
  status_code: number;
  data: IEmailValidationPeople;
  detail?: string;
  errors?: ExpectedAny[];
  constructor() {
    this.message = '';
    this.data = {
      uuid: '',
      email: '',
      reachable: false,
      has_mx_records: false,
      free: false,
      disposable: false,
      deliverable: false,
      disabled: false,
      catch_all: false,
      full_inbox: false,
      host_exists: false,
      valid: false,
      domain: null,
      is_safe: false,
      initial: false,
      updated_at: null,
    };
    this.status_code = 200;
  }
}

export class PeopleIndustry implements IResponse<IPeopleIndustry[]> {
  status_code: number;
  data: IPeopleIndustry[];
  constructor() {
    this.status_code = 200;
    this.data = [];
  }
}
